import * as React from 'react';

import { withStyles, WithStyles, createStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import RemoveCircle from '@material-ui/icons/RemoveCircle';
import AddCircle from '@material-ui/icons/AddCircle';

import { MaxBedroomCount } from 'ha/modules/Algolia/utils/filterBuilder/constants';

import Row from 'ha/ui/next/Row';
import Col from 'ha/ui/next/Col';

const styles = createStyles({
  label: {
    display: 'inline',
  },
});

interface Props {
  children: React.ReactNode;
  onChange: (value: number) => void;
  value: number;
  isDisabled?: boolean;
}

export const FilterNumberInput: React.SFC<
  Props & WithStyles<typeof styles>
> = ({ classes, onChange, value, children, isDisabled }) => (
  <Row alignItems="center">
    <Col>
      <Typography className={classes.label} variant="body1">
        {children}
      </Typography>
    </Col>

    <Col>
      <IconButton
        color="primary"
        disabled={isDisabled || value <= 0}
        onClick={() => onChange(value - 1)}
        data-test-locator="Filter Decrease"
      >
        <RemoveCircle />
      </IconButton>
      <Typography className={classes.label} variant="body1">
        {value}+
      </Typography>
      <IconButton
        color="primary"
        disabled={isDisabled || value >= MaxBedroomCount}
        onClick={() => onChange(value + 1)}
        data-test-locator="Filter Increase"
      >
        <AddCircle />
      </IconButton>
    </Col>
  </Row>
);

export default withStyles(styles)(FilterNumberInput);
